export default "__VITE_ASSET__B2VETKjj__"